import { connect } from 'react-redux';
import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';

import { Link } from '@tcc/crate';
import { getMessage } from '@tcc/i18n';

import { PanelCards } from '../../Panel';
import { FHAPreview } from '../../../components/cards/FHA/FHAPreview';
import FHAEvents from './FHAEvents';

import {
  getCurrentFHAEvent,
  nextEventSelector,
  activeSubLayerSelector,
  prevEventSelector,
  hasHistoricWeatherSelector,
} from '../../../selectors/fhaSelectors';
import { getFeatureValue } from '../../../selectors/featureSelectors';
import { setActiveSubLayer } from '../../../actions/layersActions';
import { reqWeatherData } from '../../../actions/weatherActions';
import { openModal } from '../../../actions/modalActions';

import { calcPrecipitation } from '../../../utils/weatherData';
import { FHA, FHA_KEY } from '../../../constants/mapLayerIds';
import { APPLICATION, HARVEST, PLANTING, WEATHER } from '../../../constants/cards';
import { MICROSOFT_WEATHER_GDD_GLOBAL_RELEASE } from '../../../constants/featureFlags';

const CARDS = [WEATHER, APPLICATION, PLANTING, HARVEST];

export class FHAPanel extends Component {
  UNSAFE_componentWillMount() {
    const {
      reqWeatherData: reqWeatherDataProp,
    } = this.props;

    reqWeatherDataProp();
  }

  onRightClickPreview = () => {
    const {
      nextEvent,
      currentSubLayer,
      index,
      currentSeason,
      setActiveSubLayer: setActiveSubLayerProp,
    } = this.props;
    const activeSubLayer = {
      ...currentSubLayer,
      date: nextEvent.date,
    };
    setActiveSubLayerProp(FHA_KEY, activeSubLayer, index, currentSeason);
  };

  onLeftClickPreview = () => {
    const {
      index,
      prevEvent,
      currentSeason,
      currentSubLayer,
      setActiveSubLayer: setActiveSubLayerProp,
    } = this.props;

    const activeSubLayer = {
      ...currentSubLayer,
      date: prevEvent.date,
    };

    setActiveSubLayerProp(FHA_KEY, activeSubLayer, index, currentSeason);
  };

  onToggleType = (e) => {
    const {
      currentSubLayer,
      currentSeason,
      index,
      setActiveSubLayer: setActiveSubLayerProp,
    } = this.props;
    const layerType =
      currentSubLayer.segmentSelected === FHA.SCOUTING
        ? FHA.VEGETATION
        : FHA.SCOUTING;
    const activeSubLayer = {
      ...currentSubLayer,
      layer: layerType,
      segmentSelected: layerType,
    };
    e.preventDefault();
    setActiveSubLayerProp(FHA_KEY, activeSubLayer, index, currentSeason);
  };

  render() {
    const {
      currentEvent,
      currentSubLayer,
      hasHistoricWeather,
      microsoftGDDGlobalRelease,
      index,
      isCollapsed,
      isSplitViewEnabled,
      nextEvent,
      plantingDate,
      precipitationDates,
      prevEvent,
      locale,
      collapsePanel,
    } = this.props;

    const precipitation = calcPrecipitation(
      precipitationDates,
      currentEvent.date,
      plantingDate
    );

    const firstCard =
      isSplitViewEnabled && isCollapsed ? (
        <FHAPreview
          date={currentEvent.date}
          gdus={currentEvent.gdus}
          hasHistoricWeather={hasHistoricWeather}
          microsoftGDDGlobalRelease={microsoftGDDGlobalRelease}
          locale={locale}
          lowPercent={currentEvent[FHA.SCOUTING].lowPercent}
          onLeftClick={
            prevEvent.date === currentEvent.date
              ? null
              : this.onLeftClickPreview // NOSONAR
          }
          onRightClick={
            nextEvent.date === currentEvent.date
              ? null
              : this.onRightClickPreview // NOSONAR
          }
          precipitation={precipitation}
        />
      ) : (
        <FHAEvents
          index={index}
          collapsePanel={collapsePanel}
        />
      );

    const layerType =
      currentSubLayer.segmentSelected === FHA.SCOUTING
        ? getMessage('fha.scouting')
        : getMessage('fha.vegetation');

    const typeToggle = (
      <Link onClick={this.onToggleType} testId="fha-toggle-type">
        {layerType}
      </Link>
    );

    return (
      <PanelCards
        cards={CARDS}
        firstCard={firstCard}
        headerDetail={isCollapsed ? typeToggle : null}
        index={index}
        isCollapsed={isCollapsed}
        testId="fha"
      />
    );
  }
}

FHAPanel.propTypes = {
  collapsePanel: PropTypes.func,
  currentEvent: PropTypes.object,
  currentSeason: PropTypes.string,
  currentSubLayer: PropTypes.object,
  hasHistoricWeather: PropTypes.bool.isRequired,
  index: PropTypes.number.isRequired,
  isCollapsed: PropTypes.bool.isRequired,
  isSplitViewEnabled: PropTypes.bool.isRequired,
  locale: PropTypes.string,
  nextEvent: PropTypes.object,
  plantingDate: PropTypes.string,
  precipitationDates: PropTypes.object,
  prevEvent: PropTypes.object,
  reqWeatherData: PropTypes.func,
  setActiveSubLayer: PropTypes.func,
};

function mapStateToProps(state, props) {
  const season = state.seasons.activeSeasons[props.index].id;
  const plantingData = state.planting[season];

  return {
    currentSeason: state.seasons.activeSeasons[props.index].id,
    currentEvent: getCurrentFHAEvent(state, props),
    currentSubLayer: activeSubLayerSelector(state, props),
    hasHistoricWeather: hasHistoricWeatherSelector(state),
    microsoftGDDGlobalRelease: getFeatureValue(state, { key: MICROSOFT_WEATHER_GDD_GLOBAL_RELEASE }),
    nextEvent: nextEventSelector(state, props),
    plantingDate: plantingData && plantingData.date,
    precipitationDates: state.weather.precipitation,
    prevEvent: prevEventSelector(state, props),
    locale: state.app.locale,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    ...bindActionCreators({ setActiveSubLayer, reqWeatherData, openModal }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(FHAPanel);
